import {
    AsyncPipe,
    NgIf,
    NgTemplateOutlet,
} from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    Inject,
    DOCUMENT,
} from "@angular/core";
import { RouterLink } from "@angular/router";
import {
    BannerV2Directive,
    CashierTypes,
    UserDirective,
} from "@Front-end/seed";
import { UserViewStatuses } from "@Front-end/seed/models/user";
import { RegistrationAnalyticInitSources } from "@Front-end/seed/modules/registration-v2";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
    IconComponent,
    ModalOpenType,
    NgLetDirective,
} from "@Front-end/ui";
import { LocalizeRouterPipe } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import { environment } from "../../../../../environments/environment";
import { CashierSources } from "../../../../constants/cashier-source.constants";
import { ContentTextByNamePipe } from "../../../../features/home/components/banner-slider/pipes/content-text-by-name.pipe";
import { FixButtonPalettePipe } from "../../../../pipes/fix-button-palette.pipe";
import { ResolveMinioUrlMirrorPipe } from "../../../../pipes/resolve-minio-url-mirror.pipe";
import { AppPopupsService } from "../../../../store/services/app-popups.service";
import { FixedActionComponent } from "../fixed-action/fixed-action.component";
import { ScrollToTopComponent } from "../scroll-to-top/scroll-to-top.component";

@Component({
    selector: "ls-bottom-banner",
    imports: [
        BannerV2Directive,
        AsyncPipe,
        NgIf,
        ContentTextByNamePipe,
        TranslateModule,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
        IconComponent,
        NgTemplateOutlet,
        FixButtonPalettePipe,
        UserDirective,
        NgLetDirective,
        LocalizeRouterPipe,
        RouterLink,
        ScrollToTopComponent,
        FixedActionComponent,
        ResolveMinioUrlMirrorPipe,
    ],
    templateUrl: "./bottom-banner.component.html",
    styleUrl: "./bottom-banner.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BottomBannerComponent {
    constructor(
        private popupService: AppPopupsService,
        @Inject(DOCUMENT) private document: Document,
    ) {
    }

    public minioUrl: string = environment.minioUrl;
    public showBanner: boolean = true;

    protected readonly UserViewStatuses = UserViewStatuses;
    protected readonly Number = Number;

    public closeBanner(): void {
        this.showBanner = !this.showBanner;
    }

    public openCashier(): void {
        this.popupService.fireOpenCashier({
            source: CashierSources.BOTTOM_BANNER,
            type: CashierTypes.DEPOSIT,
            openType: ModalOpenType.MANUAL,
        });
    }

    public openRegistration(): void {
        this.popupService.fireOpenRegistration({
            source: RegistrationAnalyticInitSources.BOTTOM_BANNER,
        }, ModalOpenType.MANUAL);
    }

    public openWheel(): void {
        this.popupService.fireOpenLuckyWheel(ModalOpenType.MANUAL);
    }
}
